async function updateCartDrawer() {
  const res = await fetch("/?section_id=header");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}
$(function(){
     function getCartCount() {
     setTimeout(function(){
    $.getJSON('/cart.js', function(cart){ 
      console.log(cart);
      var result = cart.item_count;
      console.log(result);
      $('.cart-count').text(result);
      });       
     },1000)
    }
      $(document).on('click','#cart-icon-bubble,.product_submit_button',function (){ 
    $(".u_cart_overlay").addClass("u_cart_drawer_oactive");
    $("html").addClass("open-drawer .open-minicart");
  });
  $(document).on('click','.u_cart_overlay,.close-cart-button,.minicart-action',function () {
    $(".u_cart_overlay").removeClass("u_cart_drawer_oactive");
    $('.u_cart_drawer').removeClass('open')
    $("html").removeClass("open-drawer .open-minicart");
  });
  $(document).on("click", ".quantity__button,.product-item__button-submit,.product_submit_button,.cart-remove", function () {
    console.log("testing");
    setTimeout(function(){
     updateCartDrawer();
    },1000)
      });
      let gift_id = $('.u_free_gift_wrapper .u_free_gift').val()
   console.log('gift id',gift_id) 
      $(document).on("click",".product_submit_button",function(){
        setTimeout(function(){
          console.log('custom click')
                        let check_pro_gift= 'false'                   
           $.getJSON('/cart.js', function(cart){ 
      console.log(cart);
      var result = cart.item_count;
      console.log(result);
           for(let i=0; i<cart.items.length;i++){
      if(cart.items[i].variant_id == gift_id ){
                   check_pro_gift= 'true'
      }
            }
           console.log('flag',check_pro_gift)
           if(check_pro_gift == 'false'){
         $.ajax({
        type:'POST',
        url:'/cart/add.js',
        data : {
        "id": gift_id  ,
        "quantity": 1,        
      },
 dataType: 'json',
        success: function(result){
        console.log('success');   
          updateCartDrawer()
          getCartCount()
      },
             error: function(err) {
        console.log('error',err); 
      },
         complete: function() {
                      console.log('complete');           
     }
                           })
                          } 
                        })                    
        },1000)
              
      });
          $(document).on('click','.u_cart_remove_button',function(){
       setTimeout(function(){
               $.getJSON('/cart.js', function(cart){ 
      console.log(cart);
      var result = cart.item_count;
      console.log(result);
      if(result == '1' ){
         $.ajax({
        type:'POST',
        url:'/cart/change.js',
        data : {
        "id": gift_id  ,
        "quantity": 0,        
      },
 dataType: 'json',
        success: function(result){
        console.log('success');   
          updateCartDrawer()
          getCartCount()
      },
             error: function(err) {
        console.log('error',err); 
      },
         complete: function() {
                      console.log('complete');           
      }
    })
  }
               })
       },1000)   
                  })
                
      $(document).on('change keyup paste', '.custom-coupon-inp', function(){ 
        $('.custom-coupon-a').attr('href', '/checkout/?discount='+ $(this).val());
        $('.custom-coupon-inp').val($(this).val());
      });
                  
})